import React from 'react';
import DataTable from '../DataTable/DataTable';
import 'antd/dist/reset.css';
import './App.css';

function App() {
  return (
    <div className="App">
      <DataTable />
    </div>
  );
}

export default App;